/**
 * ETHEREAL_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for the Ethereal / Ambient Genre.
 * Characteristics:
 * - Extremely Slow Harmonic Rhythm (Drone-like, Slow Burn).
 * - High Harmonic Complexity (Suspensions, Clusters, Extensions).
 * - "Soft Mist" Dynamics (Low variance, slow attack).
 * - High Reverb / Wet mix (implied).
 */

import { IMPRESSIONIST_ARCHETYPE } from './ImpressionistArchetype.js';

export const ETHEREAL_ARCHETYPE = {
    ...IMPRESSIONIST_ARCHETYPE,

    // Harmonic Rhythm: Very Slow. 4-8 bars per chord.
    harmonicRhythm: {
        target: 4.0,
        tolerance: 2.0,
        weight: 0.3
    },

    // Harmonic Consonance: Consonant but complex (Maj7, Sus2).
    // Avoiding harsh dissonance, favoring "pretty" dissonance.
    harmonicConsonance: {
        polarity: 'consonant',
        weight: 0.2
    },

    // Voice Distribution: "Airy".
    // High Mid and High focus. Lows are deep drones (sparse).
    voiceDistribution: {
        low: 0.20,  // Deep Drone
        mid: 0.40,  // Pads
        high: 0.40, // Sparkles / High Pads
        tolerance: 0.15,
        tuttiThreshold: 0.6, // Rarely full tutti power
        weight: 0.3
    },

    // Dynamic Range: Very low variance (Flat).
    // "Soft Mist" strategy.
    dynamicRange: {
        minVariance: 0.05, // Can be very flat
        targetVariance: 0.10,
        dynamicShape: 'flat',
        weight: 0.2
    },

    // Interval Entropy: Smooth, flowing.
    intervalEntropy: {
        stepRatio: 0.60, // Relaxed for Arpeggios/Drifting
        tolerance: 0.20,
        weight: 0.1
    }
};
